import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/index.vue";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



const routes = [
  {
    path: "/",
    name: "Home",
    redirect: (to) => {
      // 方法接收目标路由作为参数
      // return 重定向的字符串路径/路径对象
      return { path: "/index" };
    },
  },
  {
    path: "/index",
    name: "Index",
    component: () => import("@/views/index/indexs.vue"),
    // component: () => import("@/views/page/newIndex.vue"),
  },
  {
    path: "/rule",
    name: "rule",
    component: () => import("@/views/zsgView/index.vue"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search/psbView/index.vue"),
  },
  {
    path: "/searchZY",
    name: "searchZY",
    component: () => import("@/views/search/zhuanyeView/index.vue"),
  },
  {
    path: "/searchSG",
    name: "searchSG",
    component: () => import("@/views/search/shuiganView/index.vue"),
  },
  {
    path: "/searchKJ",
    name: "searchKJ",
    component: () => import("@/views/search/kuaijiView/index.vue"),
  },
  {
    path: "/searchHY",
    name: "searchHY",
    component: () => import("@/views/search/hangyeView/index.vue"),
    // component: () => import("@/views/page/newIndex.vue"),
  },
  {
    path: "/searchDY",
    name: "searchDY",
    component: () => import("@/views/search/dayiView/index.vue"),
    // component: () => import("@/views/page/newIndex.vue"),
  },
  {
    path: "/searchJCAL",
    name: "searchJCAL",
    component: () => import("@/views/search/jcalView/index.vue"),
    // component: () => import("@/views/page/newIndex.vue"),
  },


  {
    path: "/user",
    name: "user",
    component: () => import("@/views/user/user.vue"),
  },
  {
    path: "/content",
    name: "Content",
    component: () => import("@/views/content.vue"),
  },
  {
    path: "/contentSX",
    name: "contentSX",
    component: () => import("@/views/contentSX.vue"),
  },

  {
    path: "/contentDY",
    name: "Content",
    component: () => import("@/views/search/dayiView/content.vue"),
  },
  {
    path: "/filesInfo",
    name: "FilesInfo",
    component: () => import("@/views/filesInfo.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/about/about.vue"),
  },
  {
    path: "/list",
    name: "list",
    component: () => import("@/views/list/list.vue"),
  },
  {
    path: "/old",
    name: "old",
    component: () => import("@/views/page/index.vue"),
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});



export default router;
